<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <NeList ref='neList' :neArr='netype' :select='neClick'></NeList>
    </template>
    <template v-slot:right_view>
      <PlmnTableMenu @methodEnum='methodEnum'></PlmnTableMenu>
      <PlmnTable ref="plmnTable"></PlmnTable>
    </template>
  </BasicLayout>
</template>

<script>
import PlmnTable from '../../../../components/subscriberconfig/udmSubscriber/plmn/PlmnTable';
import PlmnTableMenu from '../../../../components/subscriberconfig/udmSubscriber/plmn/PlmnTableMenu';
import BasicLayout from '../../../../layouts/BasicLayout';
import NeList from '../../../../components/common/NeListNoIP';

export default {
  name: 'PlmnMainPage',
  components: {
    NeList,
    PlmnTable,
    PlmnTableMenu,
    BasicLayout,
  },
  data() {
    return {
      left: {
        show: true,
        name: this.$t("Profile.nelist"),
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: this.$t("Plmn.crumb"),
      },
      netype: [36],
    };
  },
  methods: {
    methodEnum(opcode) {
      switch (opcode) {
        case 'add':
          this.$refs.plmnTable.openAddProfilePage();
          break;
        case 'mod':
          this.$refs.plmnTable.openModProfilePage();
          break;
        case 'del':
          this.$refs.plmnTable.delProfiles();
          break;
        case 'qry':
          this.$refs.plmnTable.qryProfiles(true);
          break;
        default:
      }
    },
    neClick() {
      this.$refs.plmnTable.getGridData(this.$refs.neList.getNe());
    }
  }
};
</script>

<style scoped>

</style>
